import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';

import { AssistantAvatar } from './AssistantAvatar';
import { ChatMessageThinkingPart } from './parts/ChatMessageThinkingPart';

/**
 * Full message (avatar plus body) representing the thinking state of an agent call
 *
 * Uses the `#ChatMessageThinkingPart` under the hood for the body content
 *
 * @returns full chat thinking message component
 */
export const ChatThinkingMessage = (): ReactNode => {
  return (
    <Box sx={{ alignSelf: 'flex-start', height: 96 }}>
      <Stack direction={'row'} spacing={2}>
        <AssistantAvatar />
        <ChatMessageThinkingPart />
      </Stack>
    </Box>
  );
};
